import { create } from "zustand";
import { ServiceContainer } from "@/core/di";
import type { StaffDirectoryAttachment } from "@/core/authUser/entities/StaffDirectoryAttachment";

interface StaffDirectoryState {
  attachment: StaffDirectoryAttachment | null;
  loading: boolean;
  /**
   * Login deja interroge, quelle qu'ait ete l'issue. Sert de garde : le menu de profil se remonte
   * a chaque navigation, et sans elle la meme fiche serait rechargee a chaque ouverture d'ecran.
   */
  loadedForLogin: string | null;

  loadAttachment: (login: string) => Promise<void>;
  resetState: () => void;
}

const initialState = {
  attachment: null as StaffDirectoryAttachment | null,
  loading: false,
  loadedForLogin: null as string | null,
};

export const useStaffDirectoryStore = create<StaffDirectoryState>(
  (set, get) => ({
    ...initialState,

    loadAttachment: async (login: string) => {
      const state = get();
      if (state.loading || state.loadedForLogin === login) {
        return;
      }

      set({ loading: true });

      const result = await ServiceContainer.getInstance()
        .getRepository("users")
        .getCurrentUserStaffDirectory();

      // Sur echec on ne montre rien plutot qu'un rattachement suppose : annoncer a tort une agence
      // absente enverrait l'agent corriger un rattachement qui va peut-etre tres bien.
      set({
        attachment: result.success ? (result.data ?? null) : null,
        loading: false,
        loadedForLogin: login,
      });
    },

    resetState: () => set({ ...initialState }),
  }),
);

export type { StaffDirectoryState };
